/**
 * Created by Ella Ma on 2020/09/11.
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { DiagramBranch, DiagramNode, DiagramNodesList } from './diagram-service';
import { DiagramConfig } from './diagram.model';
import { GatewayType, TaskType } from './../../tamalelibs/models/workflow.model';
import { AutomationModelBase } from '../../tamalelibs/models/automation-base.model';

@Injectable({
    providedIn: 'root'
})
export class DiagramService {

    private nodesList: DiagramNodesList;
    diagramConfig: DiagramConfig;

    constructor() {
        this.nodesList = new DiagramNodesList([]);
    }

    appendAutomation(automation: AutomationModelBase, id: string) {
        this.nodesList.appendAutomation(automation, id);
    }

    loadNodes(nodes) {
        this.nodesList = new DiagramNodesList(nodes);
        return this.nodesList;
    }

    getNode(guid) {
        return this.nodesList.getNode(guid);
    }

    getAllTaskNodes() {
        return this.nodesList.getNodesByTypes<TaskType>([TaskType.APPROVAL, TaskType.INPUT]);
    }

    getAllGatewayNodes() {
        return this.nodesList.getNodesByTypes<GatewayType>([GatewayType.PARALLEL, GatewayType.AND, GatewayType.CONDITIONAL, GatewayType.SKIP]);
    }

    destory() {
        return this.nodesList.destory();
    }

    moveAutomation(data) {
        this.nodesList.moveAutomation(data);
    }

    moveNode(data) {
        this.nodesList.moveNode(data);
    }

    newNode(data) {
        this.nodesList.newNode(data, this);
    }

    getRootNote() {
        return this.nodesList.getRootNote();
    }

    setDiagramConfig(config) {
        this.diagramConfig = config;
    }

    serialize() {
        const nodes = this.nodesList.serialize();
        this.nodesList.sortNodes(nodes);
        return nodes;
    }

    setNodeId(guid, id) {
        return this.nodesList.setNodeId(guid, id);
    }

    updateNode(guid, data) {
        return this.nodesList.updateNode(guid, data);
    }

    updateAutomation(automation: AutomationModelBase, id: string) {
        this.nodesList.updateAutomation(automation, id);
    }

    deleteNode(guid) {
        return this.nodesList.deleteNode(guid);
    }

    deleteBranch(nodeGuid, branchGuid, service) {
        return this.nodesList.deleteBranch(nodeGuid, branchGuid, service);
    }

    isGatewayNode(node: DiagramNode) {
        const gatewayTypes: Array<any> = [GatewayType.CONDITIONAL, GatewayType.EXCLUSIVE, GatewayType.PARALLEL];
        return !!node && !!node.type && gatewayTypes.includes(node.type);
    }

    isGatewayStartNode(nodeId: string): boolean {
        const nodeRef = this.getNode(nodeId);
        const isStartNodeFunc = (node: DiagramNode, id: string) => {
            return node && node.gatewayConfig && Array.isArray(node.gatewayConfig) && Array.from(node.gatewayConfig).length > 1 && Array.from(node.gatewayConfig)[0].id === id;
        };

        if (nodeRef) {
            return isStartNodeFunc(nodeRef, nodeId);
        } else {
            return this.nodesList.getNodesByTypes<GatewayType>([GatewayType.CONDITIONAL, GatewayType.PARALLEL]).some(gNode => isStartNodeFunc(gNode, nodeId));
        }
    }

    /**
     * Returns the gateway, to which the given branch belongs.
     * Null would be returned if no gateway found.
     * @param branchId the branch id
     */
    getGatewayByBranchId(branchId: string): DiagramNode {
        if (!DiagramBranch.isBlankCondition(branchId)) {
            const gateways = this.getAllGatewayNodes();
            if (gateways && gateways.length > 0) {
                return gateways.find(gNode => gNode.branchs && gNode.branchs.length > 0 && gNode.branchs.find(branch => branch.guid && branch.guid === branchId));
            }
        }

        return null;
    }
}
